import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestFeedInsertsReorder } from "./feedInsertsReorder.request";

const useFeedInsertsReorder = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestFeedInsertsReorder,
    ...options
  });
};

export default useFeedInsertsReorder;
